<template>
  <Button
    :label="label"
    :disabled="disabled"
    :class="bindingClass"
    :icon="icon"
    :iconPos="iconPos"
    :badge="badge"
    :type="type"
    :badgeClass="badgeClass"
    @click="handeleEventClick()"
    ><div class="icon-label">
      <IziIcon v-if="matIcon">{{ matIcon }}</IziIcon
      >{{ label }}
    </div></Button
  >
</template>
<script lang="ts">
import { computed } from "vue";
import { Options } from "vue-class-component";
import BaseElement from "../BaseElement.vue";

@Options({
  props: [
    "icon",
    "iconPos",
    "badge",
    "badgeClass",
    "buttonType",
    "card",
    "matIcon"
  ],
  emits: ["click"]
})
export default class IziButton extends BaseElement {
  public icon!: string;
  public matIcon!: string;
  public iconPos!: string;
  public badge!: string;
  public badgeClass!: string;
  public buttonType!: string; //primary || other || cancel
  public bindingClass = computed(() => this.mergeClass());
  public card!: boolean;
  public handeleEventClick() {
    this.$emit("click");
  }

  protected mergeClass() {
    return `${this.buttonType} ${this.checkSizeButton()} ${this.checkTheme()} ${
      this.class
    } ${this.card ? "p-shadow-3" : ""}`;
  }
  protected checkTheme() {
    if (this.theme) {
      //icons, severities, raised, rounded, text, raised, outlined, rounded
      return `p-button-${this.theme}`;
    }
    return "";
  }
  protected checkSizeButton() {
    if (this.size) {
      return this.size ? `p-button-${this.size}` : "";
    }
    return "";
  }
}
</script>

<style lang="scss" scoped>
.p-button {
  font-weight: bold;
  place-content: center;
}

.icon-label {
  display: flex;
  align-items: center;
}
.primary {
  &.p-button {
    background: $primary-button;
    border-radius: 24px;
  }
  &.p-button:hover {
    background-color: $primary-button-hover;
  }
  &.p-button-outlined {
    background: white;
    color: $primary-button;
  }

  &.p-button-outlined:hover {
    background-color: $primary-button-hover;
    color: white;
  }
  &.p-button.p-button-text {
    background-color: transparent;
    color: $primary-button;
    border-color: transparent;
  }

  &.p-button.p-button-text:hover {
    background-color: #f2f2f2;
  }
  &.p-button.p-button-outlined {
    border: none;
  }
}

.other {
  &.p-button {
    background: $other-button;
    border-radius: 24px;
  }
  &.p-button:hover {
    background-color: $other-button;
  }
  &.p-button-outlined {
    background: white;
    color: $primary-button;
  }

  &.p-button-outlined:hover {
    background-color: $other-button;
    color: white;
  }

  &.p-button.p-button-text {
    background-color: transparent;
    color: $other-button;
    border-color: transparent;
  }

  &.p-button.p-button-text:hover {
    background-color: #ff7a3914;
  }
}
.cancel {
  &.p-button {
    background: $cancel-button;
    border-radius: 24px;
  }
  &.p-button:hover {
    background-color: $cancel-button-hover;
  }
  &.p-button-outlined {
    background: white;
    color: $primary-button;
  }

  &.p-button-outlined:hover {
    background-color: $cancel-button-hover;
    color: white;
  }

  &.p-button.p-button-text {
    background-color: transparent;
    color: $cancel-button;
    border-color: transparent;
  }

  &.p-button.p-button-text:hover {
    background-color: #ff7a3914;
  }
}
</style>
